export default __webpack_public_path__ + "static/media/vine-1.ece5b1ec.png";